import styled from "styled-components";
import { colorPalette, typeScale } from "../../../../../../utils/theme";

export const Section = styled.section`
  padding-top: 140px;
  padding-bottom: 80px;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 767.98px) {
    padding: 24px 16px;
    padding-bottom: 64px;
  }
`;

export const Stage = styled.div`
  position: relative;
  height: 500px;
  border-radius: 22px;
  background: #ebf1f766;
  box-shadow: inset 0 2px 8px rgba(0, 0, 0, 0.04);
  border: 1.51px solid var(--Blue-200, #ebf1f7);
  overflow: visible;
  width: 100%;

  @media (max-width: 767.98px) {
    height: auto;
    padding: 120px 20px 32px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    animation: slideUpMobile 0.8s ease forwards;
    margin-top: 100px;
  }

  @keyframes slideUpMobile {
    from {
      transform: translateY(50px);
      opacity: 0;
    }
    to {
      transform: translateY(0);
      opacity: 1;
    }
  }
`;

export const CenterImage = styled.img`
  position: absolute;
  width: 445px;
  height: 350px;
  left: 50%;
  transform: translateX(-50%);
  top: -170px;
  object-fit: cover;
  border-radius: 8px;
  will-change: transform;
  backface-visibility: hidden;
  transform-style: preserve-3d;

  @media (max-width: 767.98px) {
    display: none;
  }
`;

export const CenterImageMobile = styled.img`
  display: none;
  
  @media (max-width: 767.98px) {
    display: block;
    position: absolute;
    width: 100%;
    max-width: 350px;
    height: auto;
    top: -100px;
    left: 50%;
    transform: translateX(-50%);
    object-fit: contain;
    border-radius: 8px;
    will-change: transform;
    backface-visibility: hidden;
    transform-style: preserve-3d;
    z-index: 3;
  }
`;

export const LeftCard = styled.div`
  position: absolute;
  width: 420px;
  background: white;
  border-radius: 16px;
  padding: 24px;
  top: -60px;
  left: 64px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 2;
  will-change: transform;
  backface-visibility: hidden;
  transform-style: preserve-3d;

  @media (max-width: 767.98px) {
    display: none;
  }
`;

export const RightCard = styled.div`
  position: absolute;
  width: 420px;
  background: white;
  border-radius: 16px;
  padding: 16px;
  top: -60px;
  right: 64px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  z-index: 2;
  will-change: transform;
  backface-visibility: hidden;
  transform-style: preserve-3d;

  @media (max-width: 767.98px) {
    display: none;
  }
`;

export const FloatingBadge = styled.div`
  position: absolute;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 22px;
  padding: 12px 20px;
  font-size: 14px;
  font-weight: 500;
  color: #2563eb;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  z-index: 4;
  white-space: nowrap;
  will-change: transform;
  backface-visibility: hidden;
  transform-style: preserve-3d;

  @media (max-width: 767.98px) {
    display: none;
  }
`;

export const LeftFloatingBadge = styled(FloatingBadge)`
  top: -12px;
  right: -20px;
  border: 1px solid var(--Blue-200, #ebf1f7);
  color: ${colorPalette.textMain};
  ${typeScale.bodySM};
`;

export const RightFloatingBadge = styled(FloatingBadge)`
  bottom: -30px;
  left: -100px;
  border: 1px solid var(--Blue-200, #ebf1f7);
  color: ${colorPalette.textMain};
  ${typeScale.bodySM};
`;

export const BottomFloatingBadge = styled(FloatingBadge)`
  top: 100px;
  left: 450px;
  z-index: 4;
  border: 1px solid var(--Blue-200, #ebf1f7);
  color: ${colorPalette.textMain};
  ${typeScale.bodySM};
`;

export const StageFooter = styled.div`
  position: absolute;
  bottom: 28px;
  text-align: center;
  z-index: 1;
  width: 100%;

  @media (max-width: 767.98px) {
    position: static;
    transform: none;
    width: 100%;
    max-width: none;
    padding: 0;
    margin-top: 160px;
  }
`;

export const FooterBadge = styled.div`
  margin-bottom: 4px;
  text-transform: uppercase;
  color: ${colorPalette.blue500};
  ${typeScale.bodyXSMain};

  @media (max-width: 767.98px) {
    margin-bottom: 8px;
    ${typeScale.bodyXXSMain};
  }
`;

export const Headline = styled.h2`
  margin-bottom: 16px;
  color: ${colorPalette.textMain};
  ${typeScale.headingXLMain};

  @media (max-width: 767.98px) {
    margin-bottom: 12px;
    ${typeScale.headingSMMain};
  }
`;

export const Subtitle = styled.div`
  margin-bottom: 32px;
  justify-self: center;
  width: 100%;
  color: ${colorPalette.textDark};
  ${typeScale.bodyLG};
  text-align: center;

  // Make 80% width on md breakpoints
  @media (min-width: 992px) {
    width: 70%;
    margin: 0 auto 32px auto;
  }

  @media (max-width: 767.98px) {
    margin-bottom: 16px;
    ${typeScale.bodySM};
    text-align: center;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;

  @media (max-width: 767.98px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const AppButton = styled.button`
  padding: 12px 24px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: white;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: #f9fafb;
    transform: translateY(-1px);
  }

  @media (max-width: 767.98px) {
    width: 200px;
  }
`;

export const ProgressSection = styled.div`
  margin-bottom: 16px;
`;

export const ProgressTitle = styled.div`
  margin-bottom: 16px;
  text-transform: uppercase;
  color: ${colorPalette.blue500};
  ${typeScale.bodyXSMain};
`;

/* Property Contract Card */

export const PropertySection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 16px;
  margin-bottom: 24px;
`;

export const PropertyImage = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 100%;
  overflow: hidden;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const PropertyInfo = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const PropertyName = styled.h5`
  margin: 0;
  color: ${colorPalette.textMain};
  ${typeScale.headingXSMain};
`;

export const PropertyDates = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  color: ${colorPalette.textDark};
  ${typeScale.bodyXS};
`;

export const PaymentSection = styled.div`
  padding-top: 16px;
  border-top: 1px solid ${colorPalette.blue200};
`;

export const PaymentTitle = styled.h6`
  margin: 0 0 8px 0;
  color: ${colorPalette.blue500};
  ${typeScale.bodyXSMain};
`;

export const PaymentAmount = styled.div`
  color: ${colorPalette.textMain};
  ${typeScale.headingSMMain};
`;

export const CurrencyText = styled.span`
  margin-right: 4px;
  color: ${colorPalette.textDark};
  ${typeScale.bodyXS};
`;

export const PaymentDueText = styled.span`
  color: ${colorPalette.textDark};
  ${typeScale.bodyXS};
`;

export const PaymentStatusText = styled.div<{ color: string }>`
  color: ${({ color }) => color};
  ${typeScale.headingXSMain};
`;

export const ProgressBarContainer = styled.div`
  width: 100%;
  height: 4px;
  background-color: ${colorPalette.blue100};
  border-radius: 100px;
  overflow: hidden;
`;

export const ProgressBar = styled.div<{ percentage: number }>`
  height: 100%;
  width: ${({ percentage }) => percentage}%;
  background: linear-gradient(90deg, #26eab2 0%, #1f4a48 92.75%);
  transition: width 0.3s ease;
`;
